import { render, staticRenderFns } from "./EditEvent.vue?vue&type=template&id=2d1f8c6e"
import script from "./EditEvent.vue?vue&type=script&lang=js"
export * from "./EditEvent.vue?vue&type=script&lang=js"
import style0 from "./EditEvent.vue?vue&type=style&index=0&id=2d1f8c6e&prod&lang=scss"
import style1 from "./EditEvent.vue?vue&type=style&index=1&id=2d1f8c6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports